import { useApi } from "utils";
import { fillterDataType, Payload } from "../../types/CurrentStockPositionValue";
import { useState, useEffect } from "react";
import { SuccessFetch } from "types";


type PaginationType = {
  total: number
  page: number
  size: number
  pages: number
}

export const useCurrentStockPositionValue = ({ year_month, location_id, category_id, page, limit }: fillterDataType) => {
  const api = useApi();
  const [data, setData] = useState<Payload["data"]>([]); // Menggunakan tipe dari Payload
  const [pagination, setPaginationData] = useState<PaginationType | null>(null);
  const [isLoading, setLoading] = useState(false)
  
  const params: Record<string, string | number> = {
    year_month: year_month,
    ...(location_id && { location_id }),
    ...(category_id && { category_id }),
    ...(page && { page }),
    ...(limit && { limit }),
  }

  const fetchData = () => {
    setLoading(true)
    api.get("/dasboard_inventory/current-stock-position-value", { params }) 
      .then((res: SuccessFetch<{ payload: Payload, pagination_data:PaginationType }>) => {
        const payload = res.data.payload;
        setData(payload.data); // Mengakses data produk dari payload
        setPaginationData(res.data.pagination_data);
        setLoading(false)
      })
      .catch(() => {
        setData([]);
        setPaginationData(null);
        setLoading(false)
      })
      .finally(() => setLoading(false))
  };

  useEffect(() => {
    fetchData();
    return () => {
      setData([]);
      setPaginationData(null);
    };

    // eslint-disable-next-line
  }, [year_month, location_id, category_id, page, limit]);

  const fetchAll = async () => {
    const res = await api.get(
      "/dasboard_inventory/current-stock-position-value",
      {
        params: {
          year_month,
          ...(location_id && { location_id }),
          ...(category_id && { category_id }),
          page: 1,
          limit: -1
        }
      }
    );

    const payload = res.data.payload as Payload;
    return payload.data;
  };

  return { isLoading, fetchData, data, pagination, fetchAll };
};